.wrapper {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    outline: none;
    border: none;
    color: var(--ed-brand, #BA61FE);
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.051px;
    text-decoration: underline;
    background: none;
    cursor: pointer;
  }

  button:active {
    opacity: 0.5;
  }
}